import React from 'react';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { workshopUrl, eventUrl } from '../utils/externalLinks';

// Title as a new-tab link to the workshop (or event analytics) page; plain text when there is
// no id (orphan check-in names, cached responses from before ids were added). stopPropagation
// keeps a click from also firing the row-level drill-down handler.
function IdentityLink({ href, children, sx, ...rest }) {
  if (!href) return <>{children}</>;
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      onClick={(e) => e.stopPropagation()}
      sx={sx}
      {...rest}
    >
      {children}
    </Link>
  );
}

export default function WorkshopLink({ id, name, children, ...rest }) {
  return <IdentityLink href={workshopUrl(id)} {...rest}>{children ?? name}</IdentityLink>;
}

export function EventLink({ id, name, children, ...rest }) {
  return <IdentityLink href={eventUrl(id)} {...rest}>{children ?? name}</IdentityLink>;
}

// An opportunity's distinct workshops ([{id, name}] from /exec/opportunities and
// /exec/filtered/opportunities), one link per line; ids may be null (plain text).
export function WorkshopLinks({ workshops }) {
  if (!workshops?.length) return <>—</>;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {workshops.map((w, i) => (
        <WorkshopLink key={`${w.id ?? 'x'}-${w.name}-${i}`} id={w.id} name={w.name} />
      ))}
    </Box>
  );
}

export const workshopNames = (workshops) => (workshops || []).map((w) => w.name).join('; ');
